import React from 'react';
import { Modal } from 'antd';
import type { CccClientWorked } from '../api/cccApi';
import CccClientHistoryPanel from './CccClientHistoryPanel';
import CccClientNotesSection from './CccClientNotesSection';
import '../styles/recuperacao.css';

type Props = {
  open: boolean;
  client: Pick<CccClientWorked, 'workspace' | 'entity_id' | 'entity_label' | 'workspace_label'> | null;
  onClose: () => void;
};

const CccClientHistoricoModal: React.FC<Props> = ({ open, client, onClose }) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width="min(720px, 96vw)"
      centered
      destroyOnClose
      className="ccc-client-historico-modal"
      title={
        client ? (
          <div className="ccc-client-historico-modal-title">
            <span>Histórico</span>
            <span className={`ccc-monitor-ws ccc-monitor-ws--${client.workspace}`}>
              {client.workspace_label}
            </span>
            <span className="ccc-client-historico-modal-empresa">{client.entity_label}</span>
          </div>
        ) : (
          'Histórico'
        )
      }
    >
      {client ? (
        <>
          <CccClientNotesSection workspace={client.workspace} entityId={client.entity_id} />
          <CccClientHistoryPanel
            workspace={client.workspace}
            entityId={client.entity_id}
            variant="modal"
          />
        </>
      ) : null}
    </Modal>
  );
};

export default CccClientHistoricoModal;
